import type { FormDefinition, FormField } from '../types';
import { evaluateRequiredWhen } from './requiredWhen';

export function flattenFields(form: FormDefinition): FormField[] {
  return (form.sections ?? []).flatMap((s) => s.fields);
}

/**
 * True if this field is required given the current response state. Combines
 * the static `required` flag with `requiredWhen` so the form-fill UI can
 * show/hide the asterisk and the validation message live.
 */
export function isFieldRequiredNow(field: FormField, responses: Record<string, unknown>): boolean {
  if (!field.required) return false;
  return evaluateRequiredWhen(field.requiredWhen, responses);
}
